import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["value", "onChange", "id", "labelText", "width"];
import React from 'react';
import { Input as CheggUITextInput } from '@chegg-ui/input';
export var TextInput = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var value = props.value,
    onChange = props.onChange,
    id = props.id,
    labelText = props.labelText,
    width = props.width,
    optionalProps = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement(CheggUITextInput, _extends({
    value: value,
    onChange: onChange,
    inputId: id,
    labelText: labelText,
    width: width,
    ref: ref
  }, optionalProps));
});
TextInput.displayName = 'TextInputForwardRef';
export default /*#__PURE__*/React.memo(TextInput);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/components/Coupon/modules/TextInput/index.js
// module id = 3507
// module chunks = 11